function isLocalHost(): boolean {
    const isWindowDefined = typeof window !== 'undefined';

    const hostName = isWindowDefined ? window.location.hostname : '';

    if (hostName === 'localhost') {
        return true;
    }

    if (hostName === '[::1]') {
        return true;
    }

    if (/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/.exec(hostName)) {
        return true;
    }

    return false;
}

export default Object.freeze({
    isLocalHost,
});
